<template>
  <div class="collapsible">
    <div class="collapsible-header" @click="expanded = !expanded">
      <slot name="header" />
      <img
        class="collapsible-arrow"
        src="~@/assets/icons/caret.png"
        alt=""
        :class="{ 'collapsible-arrow-expanded': expanded }"
      />
    </div>
    <div v-show="expanded">
      <slot name="default" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initialExpanded: Boolean,
  },
  data() {
    return {
      expanded: this.initialExpanded || false,
    };
  },
};
</script>


<style lang="scss" scoped>
.collapsible {
  &-header {
    $block: &;
    display: flex;
    padding: 16px 0;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
  }
  &-title {
    display: flex;
    align-items: center;
  }
  &-arrow {
    display: block;
    width: 7px;
    margin-left: 8px;
    transition: transform 0.2s ease-in-out;
    &-expanded {
      transform: rotateZ(90deg);
    }
  }
}
</style>
